import { Icon } from "src/components/Icon/Icon";
import { border_radius } from "src/design-system/tokens/border";
import External from "src/design-system/icons/External.svg?react";
import {
  fontSize,
  fontWeight,
  lineHeight,
  spacing,
  type iconSize as sharedIconSize,
} from "src/theme";
import styled from "styled-components";
import { Button } from "react-aria-components";
import type { ComponentProps } from "react";

type PanePromoButtonProps = React.PropsWithChildren<{
  promoText: string;
  iconSize?: keyof typeof sharedIconSize;
  iconBgSize?: "lg" | "md";
  tagline?: string;
  onClick: ComponentProps<typeof Button>["onPress"];
}>;

export function PanePromoButton({
  promoText,
  tagline,
  children,
  onClick,
  iconBgSize,
  iconSize = "xxl",
}: PanePromoButtonProps) {
  return (
    <Button
      className="group flex cursor-pointer items-center justify-start rounded-lg border-1 border-border bg-surface p-4 hover:bg-surface-hover"
      onPress={onClick}
    >
      <LeftIconWrapper
        className="bg-surface-active group-hover:bg-surface-hover"
        iconBgSize={iconBgSize === "lg" ? "56px" : spacing.xxxxl}
      >
        <Icon size={iconSize}>{children}</Icon>
      </LeftIconWrapper>
      <TextWrapper>
        <Header>{promoText}</Header>
        {tagline && <Tagline>{tagline}</Tagline>}
      </TextWrapper>
      <External className="ml-auto h-5.5 w-5.5 text-icon-brand" />
    </Button>
  );
}

const LeftIconWrapper = styled.div<{
  iconBgSize: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${border_radius.rounded_md};
  min-width: ${({ iconBgSize }) => iconBgSize};
  min-height: ${({ iconBgSize }) => iconBgSize};
`;

const TextWrapper = styled.div`
  text-align: left;
  line-height: ${lineHeight.tight};
  margin-left: ${spacing.xl};
  margin-right: ${spacing.lg};
`;

const Tagline = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-size: ${fontSize.h6};
`;

const Header = styled.h2`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: inherit;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${fontWeight.medium};
  font-size: ${fontSize.h5};
`;
